import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DraftDocumentActions from './DraftDocumentActions';
import { formatSource } from '../../../utils/helper';
import { currencyFormatter } from '../../../utils/currencyFormat';
import CustomPagination from '../../../components/customPagination';
import { formatDate } from '../../../utils/formatDate';
import { useGetInvoicesHandler } from '../../Invoices/dataHandlers/getInvoicesHandler';

const SBDraftsInvoicesTable = ({ handlePaginationChange, searchQuery }) => {
  const navigate = useNavigate();

  const { invoices, totalDocuments, isLoading } = useGetInvoicesHandler({ searchQuery });

  const columns = [
    {
      field: 'document_number',
      headerName: 'Invoice No',
      flex: 1,
      renderCell: ({ row }) => (
        <Typography
          variant="body1"
          sx={{
            textDecoration: 'underline',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            pl: '0.7rem',
          }}
          onClick={() => navigate(`/self-billed-drafts/invoices/${row.document_id}`)}
        >
          {row.document_number}
        </Typography>
      ),
    },
    {
      field: 'document_date',
      headerName: 'Invoice Date',
      flex: 1,
      valueGetter: (params) => {
        return formatDate(params);
      },
    },
    {
      field: 'source',
      headerName: 'Submission channel',
      flex: 1,
      valueFormatter: (params) => formatSource(params),
    },
    {
      field: 'total_tax_amount',
      headerName: 'Tax',
      flex: 0.5,
      renderCell: ({ row }) =>
        row.document_currency_code === 'MYR'
          ? `RM ${currencyFormatter().format(row.total_tax_amount)}`
          : currencyFormatter(row.document_currency_code).format(row.total_tax_amount),
    },
    {
      field: 'total_payable_amount',
      headerName: 'Total',
      flex: 1,
      renderCell: ({ row }) =>
        row.document_currency_code === 'MYR'
          ? `RM ${currencyFormatter().format(row.grand_total)}`
          : currencyFormatter(row.document_currency_code).format(row.grand_total),
    },
    {
      field: 'row',
      headerName: 'Actions',
      flex: 0.3,
      sortable: false,
      renderCell: ({ row }) => (
        <DraftDocumentActions
          handleDetailsClickAction={() => navigate(`/self-billed-drafts/invoices/${row.document_id}`)}
          docType="invoices"
          row={row}
        />
      ),
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={invoices}
        columns={columns}
        getRowId={(row) => row._id}
        paginationMode="server"
        rowCount={totalDocuments}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page + 1, model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default SBDraftsInvoicesTable;
